"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.SmallBodyBoldGrey = exports.SmallBodyBold = exports.SmallBodyGrey = exports.SmallBody = exports.BodyBoldGrey = exports.BodyBold = exports.BodyGrey = exports.Body = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../Constant");

var _BodyBase = _interopRequireDefault(require("./BodyBase"));

function _templateObject15() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 1.8rem;\n  font-weight: 500;\n  letter-spacing: 0.018em;\n  line-height: ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 2.2rem;\n  font-weight: 400;\n  line-height: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 2.4rem;\n  font-weight: 400;\n  line-height: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 2.8rem;\n  font-weight: 700;\n  letter-spacing: -0.018em;\n  line-height: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  font-family: ", ";\n  font-size: 4.2rem;\n  font-weight: 700;\n  letter-spacing: -0.012em;\n  line-height: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: 0.025em; /* .325 px */\n  line-height: 1.64; /* 21.32px */\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: 0.025em; /* .325 px */\n  line-height: 1.64; /* 21.32px */\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.3rem;\n  font-weight: 400;\n  letter-spacing: 0.025em; /* .325 px */\n  line-height: 1.64; /* 21.32px */\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.3rem;\n  font-weight: 400;\n  letter-spacing: 0.025em; /* .325 px */\n  line-height: 1.64; /* 21.32px */\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: 0.0213em; /* .32px */\n  line-height: 1.54; /* 23.1px */\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: 0.0213em; /* .32px */\n  line-height: 1.54; /* 23.1px */\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 400;\n  letter-spacing: 0.0213em; /* .32px */\n  line-height: 1.54; /* 23.1px */\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1.5rem;\n  font-weight: 400;\n  letter-spacing: 0.0213em; /* .32px */\n  line-height: 1.54; /* 23.1px */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  letter-spacing: 0em;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// used for heading styles
var XS_LINE = '1.15';
var SMALL_LINE = '1.3';
var MED_LINE = '1.44';
var LARGE_LINE = '1.54';
var XL_LINE = '1.55';
var sharedStyles = (0, _styledComponents.css)(_templateObject(), _Constant.Color.DARK_GREY);
var Body = (0, _styledComponents.default)(_BodyBase.default)(_templateObject2(), _Constant.Color.BLACK_SOUL);
exports.Body = Body;
var BodyGrey = (0, _styledComponents.default)(_BodyBase.default)(_templateObject3(), _Constant.Color.DARK_GREY_2);
exports.BodyGrey = BodyGrey;
var BodyBold = (0, _styledComponents.default)(_BodyBase.default)(_templateObject4(), _Constant.Color.BLACK_SOUL);
exports.BodyBold = BodyBold;
var BodyBoldGrey = (0, _styledComponents.default)(_BodyBase.default)(_templateObject5(), _Constant.Color.DARK_GREY_2);
exports.BodyBoldGrey = BodyBoldGrey;
var SmallBody = (0, _styledComponents.default)(_BodyBase.default)(_templateObject6(), _Constant.Color.BLACK_SOUL);
exports.SmallBody = SmallBody;
var SmallBodyGrey = (0, _styledComponents.default)(_BodyBase.default)(_templateObject7(), _Constant.Color.DARK_GREY_2);
/* SmallBodyBold uses a heavier font weight than BodyBold */

exports.SmallBodyGrey = SmallBodyGrey;
var SmallBodyBold = (0, _styledComponents.default)(_BodyBase.default)(_templateObject8(), _Constant.Color.DARK_GREY_2);
exports.SmallBodyBold = SmallBodyBold;
var SmallBodyBoldGrey = (0, _styledComponents.default)(_BodyBase.default)(_templateObject9(), _Constant.Color.DARK_GREY_2); // begin heading styles

exports.SmallBodyBoldGrey = SmallBodyBoldGrey;

var H1 = _styledComponents.default.h1(_templateObject10(), sharedStyles, _Constant.Font.SECONDARY_HEADER_FONT, XS_LINE);

exports.H1 = H1;

var H2 = _styledComponents.default.h2(_templateObject11(), sharedStyles, _Constant.Font.SECONDARY_HEADER_FONT, SMALL_LINE);

exports.H2 = H2;

var H3 = _styledComponents.default.h3(_templateObject12(), sharedStyles, _Constant.Font.PRIMARY_FONT, MED_LINE);

exports.H3 = H3;

var H4 = _styledComponents.default.h4(_templateObject13(), sharedStyles, _Constant.Font.PRIMARY_FONT, MED_LINE);

exports.H4 = H4;

var H5 = _styledComponents.default.h5(_templateObject14(), sharedStyles, _Constant.Font.SECONDARY_HEADER_FONT, XL_LINE);

exports.H5 = H5;

var H6 = _styledComponents.default.h6(_templateObject15(), sharedStyles, _Constant.Font.PRIMARY_FONT, LARGE_LINE);

exports.H6 = H6;